import { Component, OnInit, inject } from '@angular/core';
import { BreadcrumbService } from '../../services/breadcrumb.service';
import { HeadService } from '../../services/head.service';
import { TitleService } from '../../services/title.service';
import { BreadCrumbComponent } from '../breadcrumb/breadcrumb.component';

@Component({
    selector: 'app-disclaimer',
    templateUrl: './disclaimer.component.html',
    styleUrls: ['./disclaimer.component.scss'],
    imports: [BreadCrumbComponent]
})
export class DisclaimerComponent implements OnInit {
  private breadcrumbService = inject(BreadcrumbService);
  private headService = inject(HeadService);
  private titleService = inject(TitleService);


  ngOnInit(): void {
    const title = 'Disclaimer';
    this.titleService.set(title);
    this.breadcrumbService.set(title);
    this.headService.setMetaDescription(title);
  }
}
